// Generated by CoffeeScript 2.7.0
var Admin__Settings__RedPacketQuotasController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsRedPacketQuotas from 'trunks/vue/admin/components/settings/settings_red_packet_quotas.js';

export default Admin__Settings__RedPacketQuotasController = (function() {
  class Admin__Settings__RedPacketQuotasController extends Skylark.App.BaseController {
    index() {
      this._generateSettingsSidebarView('settings__red_packet_quotas');
      return new SettingsRedPacketQuotas({
        el: DomMaster.find("#js-settings-red_packet_quotas").node
      });
    }

  };

  Admin__Settings__RedPacketQuotasController.include(GenerateMorePopover);

  Admin__Settings__RedPacketQuotasController.include(SettingsNavigator);

  return Admin__Settings__RedPacketQuotasController;

}).call(this);
